import { useEffect } from 'react'
import { socketService } from '@/services/socket.service'

import { WebSocketEvent } from '@/services/webSocketEvent'
import { useAuth } from '@/config/auth/context/authProvider'

export const useTablesSocket = () => {
  const user = useAuth()
  const jwt = user?.jwtToken
  useEffect(() => {
    const initializeSocket = () => {
      if (jwt) {
        if (!socketService.isConnected()) {
          socketService.connect(jwt, WebSocketEvent.TABLES_SUBSCRIBE)
        }
      }
    }

    initializeSocket()

    return () => {
      socketService.disconnect()
    }
  }, [jwt])

  return socketService
}
